/* istanbul ignore file */
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ADPResourceService } from 'digital-core';

@Component({
  selector: 'claims-no-devices-modal-window',
  templateUrl: './claims-no-devices-modal-window.component.html',
  styleUrls: ['./claims-no-devices-modal-window.component.scss']
})
export class ClaimsNoDevicesModalWindowComponent {

  constructor(
    public dialogRef: MatDialogRef<ClaimsNoDevicesModalWindowComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
    private resourceService: ADPResourceService,
  ) { }

  addMyDevices() {
    //this.dialogRef.close();
    this.dialogRef.close({
      data: {
        result: 'success'
      }
    });
  }

  getLabel(key: string) {
    return this.resourceService.getViewLabel(key);
  }

  onCancelClicked() {
    this.dialogRef.close({
      data: {
        result: 'cancel'
      }
    });
  }
}
